var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19180",
    "data-name": "Group 19180",
    transform: "translate(-243 -1210.826)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(243 1210.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12135",
    "data-name": "Path 12135",
    d: "M-22967.18-8939.262l1.234,1.654,2.047-3.207",
    transform: "translate(23211.539 10153.035)",
    fill: "none",
    stroke: "#05cb24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOn);
export default __webpack_public_path__ + "static/media/switchOn.846b23da9a3744a0ac00b59a7e458fa0.svg";
export { ForwardRef as ReactComponent };